import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "formQuantity",
    "formPurchasePolicy",
    "productCardQuantityText",
    "hideableIncrementor",
    "hiddenPurchasePolicyField",
    "plusButton",
    "minusButton",
    "modalSubtotal",
    "checkoutLineItem",
    "checkoutLineItemQuantity",
    "checkoutLineItemSubtotal",
    "checkoutLineItemPerUnitPrice",
    "checkoutFull",
    "checkoutEmpty",
  ];

  submitForm() {
    this.dispatch("submitForm");
  }

  increment(event) {
    const productSku = event.currentTarget.dataset.productSku;
    this._incrementFormValue(productSku);
  }

  decrement(event) {
    const productSku = event.currentTarget.dataset.productSku;
    this._decrementFormValue(productSku);
  }

  removeItem(event) {
    const productSku = event.currentTarget.dataset.productSku;
    this._removeAllFormValue(productSku);
  }

  selectPurchasePolicy(event) {
    const productSku = event.currentTarget.dataset.productSku;
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    let formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    this._setLineItemSubotal(productSku, formQuantity);
    this._setLineItemPerUnit(productSku, formPurchasePolicy);
    this._updateHiddenPurchasePolicy(productSku, formPurchasePolicy.value);
  }

  openModal(event) {
    const productSku = event.currentTarget.dataset.productSku;
    this._setModalSubtotal(productSku);
  }

  _setModalSubtotal(productSku) {
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    let formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    for (const subtotalTarget of this.modalSubtotalTargets) {
      if (subtotalTarget.dataset.productSku == productSku) {
        subtotalTarget.textContent = this._getFormQuantitySubtotal(
          formQuantity.value,
          formPurchasePolicy.dataset.perUnitMidPrice,
          formQuantity.dataset.hasPriceRange,
        );
      }
    }
  }

  _formatNumber(number) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(number);
  }

  _toggleIncrementor(productSku, formQuantityValue) {
    if (formQuantityValue == 0) {
      this._toggleVisibility(productSku);
    }
  }

  _toggleVisibility(productSku) {
    for (const hideableTarget of this.hideableIncrementorTargets) {
      if (hideableTarget.dataset.productSku == productSku) {
        hideableTarget.classList.toggle("hidden");
      }
    }
  }

  _updateTotalCount(totalIncrementValue) {
    this.checkoutTotalDiv = document.getElementById("checkout_count_total");
    if (this.checkoutTotalDiv) {
      this.checkoutTotalDiv.innerHTML =
        Number(this.checkoutTotalDiv.innerHTML) + Number(totalIncrementValue);
    }

    this.dispatch("updateTotalCount");
  }

  _decrementFormValue(productSku) {
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    if (Number(formQuantity.value) > 0) {
      let incrementValue = Number(formQuantity.dataset.incrementValue);
      let maxQtyValue = Number(formQuantity.dataset.maxQtyValue);
      let minQtyValue = Number(formQuantity.dataset.minQtyValue);
      formQuantity.value = Number(formQuantity.value) - Number(incrementValue);
      this._toggleIncrementor(productSku, Number(formQuantity.value));
      this._updateQuantityText(productSku, Number(formQuantity.value));
      this._togglePlusButton(
        productSku,
        maxQtyValue,
        Number(formQuantity.value),
      );
      this._toggleMinusButton(
        productSku,
        minQtyValue,
        Number(formQuantity.value),
      );
      this._updateTotalCount(-incrementValue);
      this._displayLineItem(productSku, Number(formQuantity.value));
      this._setLineItemQuantity(productSku, Number(formQuantity.value));
      this._setLineItemSubotal(productSku, formQuantity);
      this._toggleCheckoutLineItems();
    }
  }

  _incrementFormValue(productSku) {
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    let maxQtyValue = Number(formQuantity.dataset.maxQtyValue);
    let minQtyValue = Number(formQuantity.dataset.minQtyValue);
    if (Number(formQuantity.value) < maxQtyValue) {
      let incrementValue = formQuantity.dataset.incrementValue;
      this._toggleIncrementor(productSku, Number(formQuantity.value));
      formQuantity.value = Number(formQuantity.value) + Number(incrementValue);
      this._togglePlusButton(
        productSku,
        maxQtyValue,
        Number(formQuantity.value),
      );
      this._toggleMinusButton(
        productSku,
        minQtyValue,
        Number(formQuantity.value),
      );
      this._updateQuantityText(productSku, Number(formQuantity.value));
      this._updateTotalCount(incrementValue);
      this._displayLineItem(productSku, Number(formQuantity.value));
      this._setLineItemQuantity(productSku, Number(formQuantity.value));
      this._setLineItemSubotal(productSku, formQuantity);
      this._toggleCheckoutLineItems();
    }
  }

  _removeAllFormValue(productSku) {
    let formQuantity = this._getCorrespondingFormRecord(productSku);
    const priorQuantity = Number(formQuantity.value);
    formQuantity.value = 0;
    let maxQtyValue = Number(formQuantity.dataset.maxQtyValue);
    let minQtyValue = Number(formQuantity.dataset.minQtyValue);
    this._toggleIncrementor(productSku, Number(formQuantity.value));
    this._updateQuantityText(productSku, Number(formQuantity.value));
    this._togglePlusButton(productSku, maxQtyValue, Number(formQuantity.value));
    this._toggleMinusButton(
      productSku,
      minQtyValue,
      Number(formQuantity.value),
    );
    this._updateTotalCount(-priorQuantity);
    this._displayLineItem(productSku, Number(formQuantity.value));
    this._toggleCheckoutLineItems();
  }

  _displayLineItem(productSku, FormQuantityValue) {
    for (const checkoutLineItem of this.checkoutLineItemTargets) {
      if (checkoutLineItem.dataset.productSku == productSku) {
        if (FormQuantityValue > 0) {
          checkoutLineItem.classList.remove("hidden");
        } else {
          checkoutLineItem.classList.add("hidden");
        }
      }
    }
  }

  _setLineItemQuantity(productSku, FormQuantityValue) {
    for (const checkoutLineItemQuantity of this
      .checkoutLineItemQuantityTargets) {
      if (checkoutLineItemQuantity.dataset.productSku == productSku) {
        checkoutLineItemQuantity.textContent = `${FormQuantityValue} ct`;
      }
    }
  }

  _setLineItemSubotal(productSku, formQuantity) {
    let formPurchasePolicy =
      this._getCorrespondingPurchasePolicyFormRecord(productSku);
    for (const checkoutLineItemSubtotal of this
      .checkoutLineItemSubtotalTargets) {
      if (checkoutLineItemSubtotal.dataset.productSku == productSku) {
        checkoutLineItemSubtotal.textContent = this._getFormQuantitySubtotal(
          formQuantity.value,
          formPurchasePolicy.dataset.perUnitMidPrice,
          formQuantity.dataset.hasPriceRange,
        );
      }
    }
  }

  _setLineItemPerUnit(productSku, formPurchasePolicy) {
    for (const perUnitPrice of this.checkoutLineItemPerUnitPriceTargets) {
      if (perUnitPrice.dataset.productSku == productSku) {
        perUnitPrice.textContent = this._formatNumber(
          formPurchasePolicy.dataset.priceInUsd,
        );
      }
    }
  }

  _toggleCheckoutLineItems() {
    let populatedCart = this.formQuantityTargets.some(
      (x) => Number(x.value) > 0,
    );
    if (populatedCart) {
      for (const checkoutFull of this.checkoutFullTargets) {
        checkoutFull.classList.remove("hidden");
      }
      for (const checkoutEmpty of this.checkoutEmptyTargets) {
        checkoutEmpty.classList.add("hidden");
      }
    } else {
      for (const checkoutFull of this.checkoutFullTargets) {
        checkoutFull.classList.add("hidden");
      }
      for (const checkoutEmpty of this.checkoutEmptyTargets) {
        checkoutEmpty.classList.remove("hidden");
      }
    }
  }

  _updateQuantityText(productSku, formQuantityValue) {
    for (const quantityText of this.productCardQuantityTextTargets) {
      if (quantityText.dataset.productSku == productSku) {
        quantityText.innerHTML = ` ${formQuantityValue} ct`;
      }
    }
  }

  _togglePlusButton(productSku, maxQtyValue, formQuantityValue) {
    for (const plusButtonTarget of this.plusButtonTargets) {
      if (plusButtonTarget.dataset.productSku == productSku) {
        if (formQuantityValue < maxQtyValue) {
          plusButtonTarget.removeAttribute("disabled");
        } else {
          plusButtonTarget.setAttribute("disabled", true);
        }
      }
    }
  }

  _toggleMinusButton(productSku, minQtyValue, formQuantityValue) {
    for (const minusButtonTarget of this.minusButtonTargets) {
      if (minusButtonTarget.dataset.productSku == productSku) {
        if (formQuantityValue > 1) {
          // replace minus with trashcan
          minusButtonTarget.classList.remove("remove");
        } else {
          minusButtonTarget.classList.add("remove");
        }
        if (formQuantityValue > minQtyValue) {
          // disable button if bellow minimum
          minusButtonTarget.removeAttribute("disabled");
        } else {
          minusButtonTarget.setAttribute("disabled", true);
        }
      }
    }
  }

  _getCorrespondingFormRecord(productSku) {
    for (const formQuantity of this.formQuantityTargets) {
      if (formQuantity.dataset.productSku == productSku) {
        return formQuantity;
      }
    }
  }

  _getCorrespondingPurchasePolicyFormRecord(productSku) {
    for (const formPurchasePolicy of this.formPurchasePolicyTargets) {
      if (formPurchasePolicy.dataset.productSku == productSku) {
        if (formPurchasePolicy.checked) {
          return formPurchasePolicy;
        }
      }
    }
  }

  _getFormQuantitySubtotal(value, perUnitMidPrice, hasPriceRange) {
    let subtotal = Number(value) * perUnitMidPrice;
    if (hasPriceRange == "true") {
      return this._formatNumber(subtotal) + "*";
    }
    return this._formatNumber(subtotal);
  }

  _updateHiddenPurchasePolicy(productSku, purchasePolicyId) {
    for (const hiddenPurchasePolicyField of this
      .hiddenPurchasePolicyFieldTargets) {
      if (hiddenPurchasePolicyField.dataset.productSku == productSku) {
        hiddenPurchasePolicyField.value = purchasePolicyId;
      }
    }
  }
}
